import React, { useState } from "react";
import useFinancialTransactions from "../../hooks/useFinancialTransactions";
import { TRANSACTION_TYPES } from "../../constants/transactionTypes";
import TransactionForm from "../TransactionForm/TransactionForm";
import TransactionTable from "../TransactionTable/TransactionTable";
import styles from "./RevenueTab.module.css";

const RevenueTab = () => {
  const {
    transactions,
    loading,
    error,
    createTransaction,
    updateTransaction,
    deleteTransaction,
  } = useFinancialTransactions(TRANSACTION_TYPES.REVENUE);

  const [editingItem, setEditingItem] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (data) => {
    if (editingItem) {
      await updateTransaction(editingItem.id, data);
    } else {
      await createTransaction(data);
    }
    setShowForm(false);
    setEditingItem(null);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("هل أنت متأكد من الحذف؟")) {
      await deleteTransaction(id);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>الإيرادات</h3>
        <button onClick={() => { setEditingItem(null); setShowForm(true); }}>
          + إضافة الإيرادات
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}

      {showForm && (
        <TransactionForm
          initialData={editingItem}
          onSubmit={handleSubmit}
          onCancel={() => { setShowForm(false); setEditingItem(null); }}
          submitLabel={editingItem ? "تحديث" : "إضافة"}
        />
      )}

      <TransactionTable
        transactions={transactions}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default RevenueTab;